import axios from "axios";

export const comercioService = {
  // ============= FUNCIÓN BASE =============
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ============= MÉTODOS PRINCIPALES =============

  // Obtener datos del comercio
  async getComercio(idcomercio, token, conexion) {
    const endpoint = `${conexion}/api/industria/comerciopersona?idcomercio=${idcomercio}`;
    const response = await this.apiCall(endpoint, token);

    if (response.status === 200 && response.data) {
      return {
        ...response,
        mappedData: {
          comercio: this.mapComercioData(response.data),
          persona: this.mapPersonaData(response.data),
          valores: this.extractValues(response.data),
        },
      };
    }
    return response;
  },

  // Obtener actividad
  async getActividad(idactividad, token, conexion) {
    const endpoint = `${conexion}/api/industria/actividad?idactividad=${idactividad}`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener actividad por comercio
  async getActividadxComercio(idcomercio, anio, token, conexion) {
    const endpoint = `${conexion}/api/industria/actividadxcomercio?idcomercio=${idcomercio}&anio=${anio}`;
    const response = await this.apiCall(endpoint, token);

    if (response.status === 200) {
      return {
        ...response,
        mappedData: this.mapActividadxCome(response.data),
      };
    }
    return response;
  },

  // Obtener inmueble por comercio
  async getInmueblexComercio(idinmueble, token, conexion) {
    const endpoint = `${conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener deudas del comercio
  async getDeudaComercio(idcomercio, fecha, espiritu, token, conexion) {
    let endpoint;
    if (espiritu === 0) {
      endpoint = `${conexion}/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
    } else {
      endpoint = `${conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
    }
    const response = await this.apiCall(endpoint, token);

    if (response.status === 200) {
      return {
        ...response,
        mappedData: this.mapDeudas(response.data, espiritu),
      };
    }
    return response;
  },

  // Obtener multas del comercio
  async getMultas(idcomercio, token, conexion) {
    const camp = "idmulta, fechamulta, descripcion, concepto, monto, cancelada";
    const tabla = "multa";
    const nombreid = "idcontribuyente";
    const nombreid2 = "tablacontribuyente";
    const valorid2 = "comercio";
    const nombreid3 = "tipoimpuesto";
    const valorid3 = "ACTIVIDADES ECONOMICAS";
    const endpoint = `${conexion}/api/consulta/modeli3string?campos=${camp}&id=${idcomercio}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener facturas pagadas
  async getFacturasPagadas(idcomercio, token, conexion) {
    const campos = "*";
    const nomtab = `seleccionar_facturas_pagadas_web(${idcomercio})`;
    const orden = "numfactura";
    const endpoint = `${conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    return await this.apiCall(endpoint, token);
  },
  // Obetener Retencios
  async getRetenciones(idcomercio, token, conexion) {
    const endpoint = `${conexion}/api/industria/retencionesxagente?idcomercio=${idcomercio}`;
    return await this.apiCall(endpoint, token);
  },
  // ============= MAPEADORES =============

  // Mapear datos básicos del comercio
  mapComercioData(data) {
    if (!data) return null;
    return {
      codigo: data.idcomercio,
      nombre: data.nombre,
      direccion: data.direccion,
      rif: data.rif,
      cedula: data.reprelegal,
    };
  },

  // Mapear datos de la persona (representante legal)
  mapPersonaData(data) {
    if (!data || data.idcomercio <= 0) return null;
    return {
      cedula: data.cedula,
      nombres: data.nombres,
      apellidos: data.apellidos,
      correoe: data.correoe,
      tlf1: data.tlf1,
      tlf2: data.tlf2,
      fnacimiento: data.fnacimiento,
      nacionalidad: data.nacionalidad,
      sexo: data.sexo,
      direccion: data.direccionp,
    };
  },

  // Mapear actividades del comercio
  mapActividadxCome(data) {
    if (!data || data.length === 0) return [];
    return data.map((act) => ({
      alicuota: act.alicuota,
      codigoactividad: act.codigoactividad,
      codigociu: act.codigociu,
      descripcion: act.descripcion,
      idactividad: act.idactividad,
      minimo: act.minimo,
    }));
  },

  // Mapear deudas del comercio
  mapDeudas(data, espiritu) {
    if (!data || data.length === 0) return { deu: [], his: [] };

    const deu = [];
    const his = [];

    data.forEach((item) => {
      const deudaBase = {
        anio: item.anio,
        mes: item.mes?.replace(/'/g, ""),
        monto: item.mondeu,
        intereses: item.intmoradeu,
        recargo: item.recargodeu,
        multa: item.multa,
        retenciones: item.retencion,
        credito: item.acreditacion,
        totalperi: item.subtotal,
        status: item.estatus,
        idfac: item.idfact,
        nummes: item.nmes,
        estatusfac: item.estatusfac,
        tipotransaccion: item.tipotransaccion,
        tipodeuda: item.tipodeuda,
        nombredeuda: espiritu === 0 ? item.nombredeuda : "deudacomercio",
        idrent: espiritu === 0 ? item.idrent : 0,
      };

      if (item.fechapago === null) {
        deu.push(deudaBase);
      } else {
        his.push({
          ...deudaBase,
          descuento: item.mondescue,
          recibo: item.numreci,
          fechapago: item.fechapago,
        });
      }
    });

    return { deu, his };
  },

  // Mapear multas
  mapMultas(data) {
    if (!data || data.length === 0) return [];
    return data.map((multa) => ({
      idmulta: multa.idmulta,
      fechamulta: multa.fechamulta,
      descripcion: multa.descripcion,
      concepto: multa.concepto,
      monto: multa.monto,
      cancelada: multa.cancelada,
    }));
  },

  // Mapear facturas pagadas
  mapFacturasPagadas(data) {
    if (!data || data.length === 0) return [];
    return data.map((factura) => ({
      idfactura: factura.idfactura,
      numero: factura.numero,
      fecha: factura.fecha,
      monto: factura.monto,
      concepto: factura.concepto,
      estatus: factura.estatus,
      fechapago: factura.fechapago,
    }));
  },

  // Extraer valores comunes del comercio
  extractValues(data) {
    return {
      idactividad: data?.idactividad ?? 0,
      idinmueble: data?.idinmueble ?? 0,
      esagente: data?.esagentereten ?? false,
    };
  },
};
